module.exports = __webpack_public_path__ + "static/OpenSans-SemiBoldItalic-8438c758b87f2c6d3a8ecda8031f80ed.woff";